export const trimAndLower = (input) => {
    return input.trim().toLowerCase()
}
